export default {
  offset: 46
}
